<script setup lang="ts"></script>
<template>
  <v-alert
    type="info"
    title="Alert summary goes here"
    text="Optional details here what happens when there is more text."
  />
</template>
